import { Div, Link, Span } from "@tblabs/truffle";
import { Center } from "../../../Components/Utils/Center";
import { PrimaryButton } from "../../../Components/Utils/PrimaryButton";
import { CopiableText } from "../../../Components/CopiableText";
import { TXv4AccessData } from "./TXv4AccessData";


export class TXv4AccessInfoBox extends Div
{
    constructor(data: TXv4AccessData)
    {
        super();

        if (data.Version === "4.0.0")
        {
            this.Background("#fff3f3").Padding(12).BorderRadius(8).Border(1, "#eee", 8).MarginTop(8).TextAlignLeft();

            this.Append(
                "Dostęp do kamery ", new Span(data.DeviceId).Bold(), ":",
                new Center(
                    new PrimaryButton("Otwórz podgląd").Margin(8)
                        .OnClick(() => { window.open(data.LaunchLink, "_blank"); })
                ),
                "lub wejdź na stronę:\n",
                new Link(data.LoginLink).OpenInNewCard(),
                "\ni wpisz: ", new CopiableText(data.Password).Bold()
            );
        }
    }
}
